/* ============ SHILAMI VITALITÁS KVÍZ — motor v3 (Shadow DOM) ============ */
(function(){
"use strict";
var host=document.getElementById('shq-host');
if(!host)return;
var PRODUCT_URL=host.getAttribute('data-product-url')||'#';
var WEBHOOK=host.getAttribute('data-webhook')||'';
var PRICE=host.getAttribute('data-price')||'';
var COMPARE=host.getAttribute('data-compare')||'';
var BADGE=host.getAttribute('data-badge')||'';
var LOGO=host.getAttribute('data-logo')||'';
var AGE_IMGS=(host.getAttribute('data-age-imgs')||'').split('|');

/* A teljes CSS a shadow rootba kerül, így a téma stílusai nem tudnak beleírni */
var CSS="\n/* ============ SHILAMI KVÍZ — CSS ============ */\n.shq{\n  --bg:#0b0a08;--bg2:#14120d;--card:#1b1812;--card2:#242015;\n  --line:rgba(255,255,255,.10);\n  --gold:#e5a039;--gold2:#f2c069;--gold-soft:rgba(229,160,57,.16);\n  --text:#f7f4ec;--dim:#cfc8b8;--faint:#8a8272;\n  --green:#2fca7c;--red:#e8564a;\n  --sheet:#ffffff;--ink:#171512;--ink-dim:#5a544a;\n  --font:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Helvetica,Arial,sans-serif;\n  position:fixed;inset:0;z-index:9999;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;\n  background:var(--bg);color:var(--text);font-family:var(--font);\n  font-size:16px;line-height:1.55;-webkit-font-smoothing:antialiased;\n  background-image:radial-gradient(ellipse 95% 45% at 50% -8%,rgba(229,160,57,.14),transparent 60%),\n                   radial-gradient(ellipse 70% 40% at 50% 112%,rgba(229,160,57,.05),transparent 60%);\n}\n.shq *{box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:transparent}\n.shq .wrap{max-width:560px;margin:0 auto;min-height:100%;display:flex;flex-direction:column;padding:20px 20px 48px}\n.shq .top{display:flex;justify-content:center;padding:10px 0 26px}\n.shq .logo-img{height:34px;width:auto;display:block}\n.shq .progress{height:4px;border-radius:99px;background:rgba(255,255,255,.08);overflow:hidden;margin-bottom:26px}\n.shq .progress__fill{height:100%;width:0%;border-radius:99px;background:linear-gradient(90deg,var(--gold),var(--gold2));transition:width .35s ease}\n.shq .stage{flex:1;display:flex;flex-direction:column}\n.shq .screen{animation:shq-in .32s ease both}\n@keyframes shq-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}\n\n.shq h1,.shq h2{font-weight:800;text-transform:uppercase;letter-spacing:.04em;line-height:1.18}\n.shq h1{font-size:30px;margin-bottom:22px;color:var(--text)}\n.shq h2{font-size:24px;margin-bottom:16px;color:var(--text)}\n.shq .accent{color:var(--gold)}\n.shq .sub{color:var(--dim);margin-bottom:18px}\n.shq .meta{display:flex;gap:16px;flex-wrap:wrap;color:var(--dim);font-size:14px;margin-bottom:22px}\n.shq .meta b{color:var(--text)}\n\n.shq .btn{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;\n  border:0;border-radius:14px;padding:18px 22px;cursor:pointer;\n  font-family:var(--font);font-weight:800;font-size:17px;letter-spacing:.08em;text-transform:uppercase;\n  background:linear-gradient(180deg,var(--gold2),var(--gold));color:#1a1406;\n  box-shadow:0 10px 30px rgba(229,160,57,.35);transition:transform .15s ease,box-shadow .15s ease}\n.shq .btn:active{transform:scale(.98)}\n.shq .btn--ghost{background:#efece4;color:var(--ink);box-shadow:none}\n.shq .btn--pulse{animation:shq-pulse 2.2s ease-in-out infinite}\n.shq .btn .arr{display:inline-block;animation:shq-arr 1.1s ease-in-out infinite}\n@keyframes shq-arr{0%,100%{transform:translateX(0)}50%{transform:translateX(7px)}}\n@keyframes shq-pulse{\n  0%,100%{box-shadow:0 10px 30px rgba(229,160,57,.35)}\n  50%{box-shadow:0 10px 46px rgba(229,160,57,.65)}\n}\n@media (prefers-reduced-motion:reduce){\n  .shq .btn--pulse,.shq .btn .arr{animation:none}\n  .shq .screen{animation:none}\n  .shq .gauge .dot,.shq .gauge .tip,.shq .bar .col{transition:none}\n}\n\n.shq .opts{display:flex;flex-direction:column;gap:12px;margin:6px 0 4px}\n.shq .opt{display:flex;align-items:center;gap:14px;width:100%;text-align:left;cursor:pointer;\n  background:var(--card);border:1px solid var(--line);border-radius:14px;padding:16px 18px;\n  color:var(--text);font-family:var(--font);font-size:16px;font-weight:600;\n  transition:border-color .15s ease,background .15s ease}\n.shq .opt:hover{border-color:var(--gold)}\n.shq .opt .ico{font-size:20px;width:26px;text-align:center;flex:0 0 auto}\n.shq .opt .lbl{flex:1}\n.shq .opt .ring{flex:0 0 auto;width:22px;height:22px;border-radius:50%;border:2px solid var(--faint);transition:all .15s ease}\n.shq .opt.is-sel{border-color:var(--gold);background:var(--gold-soft)}\n.shq .opt.is-sel .ring{border-color:var(--gold);background:var(--gold);box-shadow:inset 0 0 0 4px var(--bg)}\n\n.shq .grid2{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:6px 0 4px}\n.shq .agecard{cursor:pointer;background:var(--card);border:1px solid var(--line);border-radius:16px;\n  padding:10px 10px 14px;text-align:center;color:var(--text);font-family:var(--font);\n  transition:border-color .15s ease,transform .15s ease}\n.shq .agecard:hover{border-color:var(--gold);transform:translateY(-2px)}\n.shq .agecard.is-sel{border-color:var(--gold);background:var(--gold-soft)}\n.shq .agecard .ph{display:block;border-radius:12px;overflow:hidden;margin-bottom:10px;background:var(--card2)}\n.shq .agecard .ph img{display:block;width:100%;height:auto;aspect-ratio:3/4;object-fit:cover}\n.shq .agecard .rng{font-weight:800;font-size:18px;letter-spacing:.08em}\n\n.shq .back{margin-top:18px;background:none;border:0;color:var(--faint);cursor:pointer;\n  font-family:var(--font);font-size:14px;align-self:flex-start}\n.shq .back:hover{color:var(--dim)}\n\n.shq .why{margin-top:20px;background:var(--card);border:1px solid var(--line);border-left:3px solid var(--gold);\n  border-radius:12px;padding:14px 16px;font-size:14px;color:var(--dim)}\n.shq .why b{display:block;color:var(--gold);text-transform:uppercase;letter-spacing:.1em;font-size:12px;margin-bottom:6px}\n\n.shq .feedback{margin-top:14px;border-radius:12px;padding:14px 16px;font-size:14.5px;\n  background:var(--card);border:1px solid var(--line);color:var(--dim);animation:shq-in .3s ease both}\n.shq .feedback b{display:block;margin-bottom:4px;color:var(--text)}\n.shq .feedback.warn{border-left:3px solid var(--red)}\n.shq .feedback.good{border-left:3px solid var(--green)}\n\n.shq .inter{margin:auto 0;text-align:left}\n.shq .inter .bigem{font-size:44px;margin-bottom:14px;display:block}\n.shq .inter p{color:var(--dim);margin-bottom:14px}\n.shq .inter ul{list-style:none;margin:0 0 18px}\n.shq .inter li{padding:10px 0;border-bottom:1px solid var(--line);color:var(--text);font-weight:600}\n.shq .inter li span{color:var(--gold);margin-right:8px}\n.shq .iblock{display:flex;gap:12px;background:var(--card);border:1px solid var(--line);border-radius:14px;padding:14px 16px;margin-bottom:10px;text-align:left}\n.shq .iblock .ie{font-size:22px;flex:0 0 auto;padding-top:2px}\n.shq .iblock b{display:block;margin-bottom:3px;color:var(--text)}\n.shq .iblock p{color:var(--dim);font-size:14.5px;margin:0}\n.shq .inote{border-left:3px solid var(--gold);background:var(--card);border-radius:12px;padding:13px 16px;margin:14px 0}\n.shq .inote b{display:block;color:var(--text);margin-bottom:4px}\n.shq .inote p{color:var(--dim);font-size:14.5px;margin:0}\n\n.shq .loadrows{display:flex;flex-direction:column;gap:12px;margin-top:18px}\n.shq .lrow{background:var(--card);border:1px solid var(--line);border-radius:12px;padding:14px 16px;\n  display:flex;justify-content:space-between;align-items:center;font-size:15px;color:var(--dim)}\n.shq .lrow b{color:var(--text);font-weight:600}\n.shq .lrow .pct{color:var(--gold);font-weight:800;font-variant-numeric:tabular-nums}\n.shq .lrow.done .pct{color:var(--green)}\n\n.shq .modal-bg{position:fixed;inset:0;background:rgba(5,4,2,.72);backdrop-filter:blur(3px);\n  display:flex;align-items:center;justify-content:center;z-index:10000;padding:24px;animation:shq-in .25s ease both}\n.shq .modal{background:var(--sheet);color:var(--ink);border-radius:18px;max-width:420px;width:100%;\n  padding:28px 24px;text-align:center;animation:shq-pop .3s cubic-bezier(.34,1.4,.64,1) both}\n@keyframes shq-pop{from{opacity:0;transform:scale(.85)}to{opacity:1;transform:scale(1)}}\n.shq .modal h3{font-size:18px;letter-spacing:.14em;text-transform:uppercase;font-weight:800;margin-bottom:12px}\n.shq .modal p{color:var(--ink-dim);margin-bottom:20px}\n.shq .modal .mrow{display:flex;gap:12px}\n.shq .modal .mbtn{flex:1;border:0;border-radius:12px;padding:15px;cursor:pointer;\n  font-family:var(--font);font-weight:800;letter-spacing:.1em;text-transform:uppercase;font-size:15px}\n.shq .modal .mbtn.no{background:#efece4;color:var(--ink-dim)}\n.shq .modal .mbtn.yes{background:var(--green);color:#fff}\n\n.shq .sheet{background:var(--sheet);color:var(--ink);border-radius:20px;padding:26px 22px;margin-bottom:18px}\n.shq .sheet .tag{color:#b07f22;font-weight:800;letter-spacing:.16em;text-transform:uppercase;font-size:12.5px;margin-bottom:10px}\n.shq .sheet h2{color:var(--ink);text-transform:none;letter-spacing:0;font-size:24px}\n.shq .rowline{display:flex;justify-content:space-between;align-items:center;margin:10px 0 16px}\n.shq .pill{background:#fdeaea;color:#c0392b;font-weight:800;border-radius:99px;padding:6px 14px;font-size:14px}\n.shq .avatarwrap{display:flex;justify-content:center;margin:6px 0 -6px}\n.shq .avatarwrap img{width:150px;height:auto;border-radius:14px;display:block}\n.shq .gauge{position:relative;height:14px;border-radius:99px;margin:38px 0 8px;\n  background:linear-gradient(90deg,#e74c3c,#e67e22,#f1c40f,#2ecc71)}\n.shq .gauge .dot{position:absolute;top:50%;left:2%;transform:translate(-50%,-50%);width:26px;height:26px;border-radius:50%;\n  background:#fff;border:4px solid #171512;box-shadow:0 2px 8px rgba(0,0,0,.3);\n  transition:left 1.1s cubic-bezier(.22,.9,.36,1)}\n.shq .gauge .tip{position:absolute;bottom:22px;left:2%;transform:translateX(-50%);background:#171512;color:#fff;\n  font-size:12.5px;font-weight:700;padding:5px 10px;border-radius:8px;white-space:nowrap;\n  transition:left 1.1s cubic-bezier(.22,.9,.36,1)}\n.shq .gscale{display:flex;justify-content:space-between;color:var(--ink-dim);font-size:13.5px;margin-bottom:18px}\n.shq .alertbox{background:#fdf1ee;border-radius:14px;padding:16px;margin-bottom:16px}\n.shq .alertbox b{display:flex;align-items:center;gap:8px;color:#c0392b;margin-bottom:6px}\n.shq .alertbox p{color:#6b4a42;font-size:14.5px}\n.shq .cells{display:grid;grid-template-columns:1fr 1fr;gap:12px}\n.shq .cell{border-radius:14px;padding:14px}\n.shq .cell .ct{font-size:12px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;margin-bottom:6px}\n.shq .cell .cv{font-weight:800;font-size:16px;color:var(--ink)}\n.shq .cell.c1{background:#f4f2ee}.shq .cell.c1 .ct{color:#b07f22}\n.shq .cell.c2{background:#fdf6e8}.shq .cell.c2 .ct{color:#b07f22}\n\n.shq .bars{display:flex;align-items:flex-end;gap:10px;height:210px;margin:8px 0 6px}\n.shq .bar{flex:1;display:flex;flex-direction:column;align-items:center;gap:8px;height:100%;justify-content:flex-end}\n.shq .bar .col{width:100%;height:0%;border-radius:10px 10px 4px 4px;background:#e8e4dc;position:relative;\n  transition:height .9s cubic-bezier(.22,.9,.36,1)}\n.shq .bar.goal .col{background:linear-gradient(180deg,var(--gold2),var(--gold))}\n.shq .bar.last .col{background:#2ecc71}\n.shq .bar .goalb{position:absolute;top:-14px;left:50%;transform:translate(-50%,-100%);\n  background:#fdf0d5;color:#8a5b00;font-weight:800;font-size:12.5px;border-radius:99px;padding:5px 12px}\n.shq .bar .wk{color:var(--ink-dim);font-size:12.5px;white-space:nowrap}\n.shq .chartnote{color:var(--dim);margin:14px 0 20px}\n.shq .chartnote b{color:var(--text)}\n\n.shq .narr{background:#fdf6e8;border-radius:14px;padding:16px;color:#5a4a28;font-size:15px;margin-bottom:18px}\n.shq .narr b{color:#171512}\n.shq .mech{display:flex;gap:12px;margin-bottom:14px}\n.shq .mech .mi{color:var(--gold);font-size:18px;flex:0 0 auto;padding-top:1px}\n.shq .mech p{font-size:14.5px;color:var(--ink-dim)}\n.shq .mech p b{color:var(--ink)}\n.shq .ingr{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin:16px 0 20px}\n.shq .ing{background:#f4f2ee;border-radius:12px;padding:12px 14px;display:flex;justify-content:space-between;align-items:center;font-size:14.5px}\n.shq .ing b{color:var(--ink);font-weight:700}\n.shq .ing span{color:#b07f22;font-weight:800}\n.shq .offer{display:flex;gap:14px;align-items:center;margin:4px 0 14px}\n.shq .offer .badge{flex:0 0 auto;width:64px;height:64px;border-radius:14px;display:flex;flex-direction:column;\n  align-items:center;justify-content:center;background:linear-gradient(180deg,var(--gold2),var(--gold));\n  color:#1a1406;font-weight:800;font-size:15px;line-height:1.1}\n.shq .offer .badge small{font-size:10px;letter-spacing:.08em}\n.shq .offer h3{font-size:20px;font-weight:800;color:var(--ink)}\n.shq .offer .osub{color:var(--ink-dim);font-size:14px}\n.shq .checks{list-style:none;margin:0 0 14px}\n.shq .checks li{padding:7px 0;color:var(--ink-dim);font-size:15px}\n.shq .checks li::before{content:\"✓\";color:var(--green);font-weight:800;margin-right:10px}\n.shq .guarantee{display:flex;align-items:center;justify-content:center;gap:8px;color:var(--ink-dim);font-size:14.5px;padding-top:6px;border-top:1px solid #eee7da}\n.shq .disclaimer{color:var(--faint);font-size:12.5px;text-align:center;margin-top:16px;line-height:1.5}\n@media (max-width:420px){\n  .shq h1{font-size:25px}.shq h2{font-size:21px}\n  .shq .bars{height:170px}\n}\n";

/* A téma/optimalizáló az üresnek látszó divet elrejtheti (div:empty) — kényszerítjük a megjelenítést */
host.style.setProperty('display','block','important');
host.style.setProperty('visibility','visible','important');
host.style.setProperty('opacity','1','important');
host.style.setProperty('position','fixed','important');
host.style.setProperty('inset','0','important');
host.style.setProperty('z-index','2147483000','important');

var sr=host.attachShadow({mode:'open'});
sr.innerHTML='<style>'+CSS+'</style>'
 +'<div class="shq" id="shq"><div class="wrap">'
 +'<div class="top">'+(LOGO?'<img class="logo-img" src="'+LOGO+'" alt="Shilami" width="160" height="27">':'')+'</div>'
 +'<div class="progress" id="shq-progress" hidden><div class="progress__fill" id="shq-fill"></div></div>'
 +'<div class="stage" id="shq-stage"></div>'
 +'</div></div>';
var root=sr.getElementById('shq');
var stage=sr.getElementById('shq-stage');
var pwrap=sr.getElementById('shq-progress');
var pfill=sr.getElementById('shq-fill');

/* A mögöttes oldal ne görgethessen — csak a kvíz belseje, ha nem fér ki */
document.documentElement.style.overflow='hidden';
document.body.style.overflow='hidden';

/* ---------- Lépések (tartalom) ---------- */
var OPTS={
  age:[
    {k:'35-44'},{k:'45-54'},{k:'55-64'},{k:'65+'}
  ],
  fo:[
    {k:'kedv',em:'🪫',l:'Ritkán kívánom a szexet — sokszor eszembe sem jut'},
    {k:'test',em:'🧠',l:'Fejben szeretném, de a testem nem követi'},
    {k:'energia',em:'🔋',l:'Mire este odaérnénk, teljesen elfogy belőlem minden'},
    {k:'erekcio',em:'⚡',l:'Nehezebben lesz vagy marad meg az erekció'},
    {k:'kerulom',em:'🙈',l:'Inkább kerülöm a helyzetet, nehogy megint ne menjen'},
    {k:'tobb',em:'🔀',l:'Több is igaz rám'}
  ],
  anx:[
    {k:'igen',l:'Igen — és ettől még jobban befeszülök'},
    {k:'nem',l:'Nem'}
  ],
  impact:[
    {k:'nagyon',l:'Nagyon'},
    {k:'valamennyire',l:'Valamennyire'},
    {k:'kicsit',l:'Csak egy kicsit'}
  ],
  when:[
    {k:'tobbeve',l:'Több éve, fokozatosan'},
    {k:'egyeve',l:'Kb. egy éve'},
    {k:'parhonapja',l:'Az elmúlt hónapokban'},
    {k:'nemtudom',l:'Nehéz megmondani — lassan kúszott be'}
  ],
  goal:[
    {k:'vagy',l:'Magasabb szexuális vágyat'},
    {k:'erekcio',l:'Erősebb és megbízhatóbb erekciót'},
    {k:'energia',l:'Több energiát napközben és este'},
    {k:'onbizalom',l:'Nagyobb magabiztosságot az ágyban'},
    {k:'stressz',l:'Kevesebb stresszt és túlgondolást'},
    {k:'kapcsolat',l:'Hogy újra közelebb kerüljünk a párommal'},
    {k:'mind',l:'Mindet'}
  ],
  rel:[
    {k:'regota',l:'Házas / kapcsolatban, 10+ éve'},
    {k:'par_eve',l:'Kapcsolatban, pár éve'},
    {k:'szingli',l:'Szingli vagyok / randizom'},
    {k:'bonyolult',l:'Bonyolult'}
  ],
  sexlife:[
    {k:'leallt',l:'Gyakorlatilag leállt'},
    {k:'ritkabb',l:'Ritkább, mint szeretném'},
    {k:'rutin',l:'Megvan, de rutinból — elcsendesedett'},
    {k:'elegedett',l:'Elégedett vagyok'}
  ],
  tried:[
    {k:'tabletta',l:'Potencianövelő tabletta'},
    {k:'koffein',l:'Kávé, energiaital — „összekapom magam”'},
    {k:'eletmod',l:'Edzés, életmódváltás'},
    {k:'semmi',l:'Semmivel — erről nem beszélek senkivel'},
    {k:'egyeb',l:'Egyéb'}
  ],
  morning:[
    {k:'igen',l:'Igen'},
    {k:'nem',l:'Nem'},
    {k:'nemtudom',l:'Nem vagyok biztos'}
  ],
  stressz:[
    {k:'folyamatos',l:'Szinte állandó — éjjel sem áll le az agyam'},
    {k:'gyakran',l:'Hetente többször feszült vagyok'},
    {k:'neha',l:'Néha'},
    {k:'ritkan',l:'Ritkán'}
  ]
};
var TRIED_FB={
  tabletta:{cls:'warn',t:'A tabletta a tünetre megy, nem az okra',p:'Időzíteni kell, nyomás alatt kell „teljesíteni” — és a kedvet, ami el sem indul, nem hozza vissza. Ha a rendszer feszült üzemmódban ragadt, az csak plusz stressz.'},
  koffein:{cls:'warn',t:'A koffein kölcsönvett energia',p:'Rövid löketet ad, de a feszültséget tovább pörgeti, és estére nagyobb a zuhanás. Az okot, ami a kedvet elnyomja, nem kezeli.'},
  eletmod:{cls:'good',t:'Ez remek alap!',p:'Az edzés és az étrend a legjobb kiindulás. A megfelelő támogatással kombinálva sokkal hamarabb érezhető a különbség.'},
  semmi:{cls:'good',t:'Nem vagy egyedül',p:'A legtöbb férfi erről senkivel nem beszél — se orvossal, se a párjával. Épp ezért készült ez a kvíz: névtelen, és a végén konkrét tervet kapsz.'},
  egyeb:{cls:'good',t:'Rendben',p:'A lényeg, hogy most a kiváltó okot célozzuk — a válaszaid alapján ezt rakjuk össze.'}
};
var STEPS=[
 {id:'intro',type:'intro'},
 {id:'age',type:'age',q:'Hány éves vagy?'},
 {id:'fo',type:'single',q:'Mi változott meg leginkább a szexuális életedben?'},
 {id:'anx',type:'single',q:'Előfordul, hogy már előre azon jár az eszed: „vajon most menni fog?”'},
 {id:'impact',type:'single',q:'Mennyire vitte el ez az önbizalmad vagy a kapcsolatod?'},
 {id:'when',type:'single',q:'Mikor kezdted észrevenni a változást?',
  why:'A vitalitás 40 felett lassan, évről évre kopik — ezért nehéz megmondani, mikor kezdődött. Nem egyik napról a másikra történt, ezért nem is tűnt fel.'},
 {id:'goal',type:'multi',q:'Mit szeretnél elérni?',sub:'Többet is megjelölhetsz.'},
 {id:'inter1',type:'inter',h:'Van kiút — és egyszerűbb lehet, mint gondolnád',
  lead:'A válaszaid alapján valószínűleg nem egyetlen dolog változott meg. 45 éves kor felett gyakran három terület kezd egyszerre dolgozni a férfi lendülete ellen:',
  blocks:[
   {em:'⚡',t:'Alacsonyabb energiaszint',p:'Mire eljön az este, már alig marad benned fizikai vagy mentális energia a közelséghez.'},
   {em:'🧠',t:'Állandó stressz és túlpörgés',p:'A tested pihenne, de az agyad tovább dolgozik. Ebben az állapotban nehezebb ellazulni és ráhangolódni.'},
   {em:'♂️',t:'Csökkenő férfi vitalitás',p:'A vágy ritkábban indul el magától, a testi reakciók kiszámíthatatlanabbá válhatnak, és az önbizalom is csökkenhet.'}
  ],
  note:{t:'Ez nem azt jelenti, hogy „megöregedtél”',p:'Inkább azt, hogy a szervezeted már nem kapja meg ugyanazt a támogatást, amelyre a vágyhoz, az energiához és a férfias lendülethez szüksége van.'},
  p:'A jó hír: egy egyszerű és következetes napi rutinnal elkezdhetsz tenni azért, hogy újra önmagadnak érezd magad.'},
 {id:'rel',type:'single',q:'Mi a helyzet otthon?'},
 {id:'sexlife',type:'single',q:'Hogy írnád le a szexuális életed mostanában?'},
 {id:'tried',type:'tried',q:'Mivel próbálkoztál eddig?'},
 {id:'inter2',type:'inter',em:'⏱️',h:'Nem kell hozzá felforgatnod az életed.',
  list:['Napi 2 gumivitamin — kb. 10 másodperc','Nincs recept, nincs kínos beszélgetés, diszkrét csomagolás','A válaszaid alapján személyre szabott terv'],
  p:'Már csak két kérdés, és összeállítjuk a profilod.'},
 {id:'morning',type:'single',q:'Észrevettél csökkenést a reggeli erekcióban?',
  why:'A reggeli erekció a férfi vitalitás egyik hétköznapi jelzője. Ha ritkul, az gyakran ugyanarra a háttérfolyamatra utal, ami a kedvet is visszafogja.'},
 {id:'stressz',type:'single',q:'Milyen a stressz-szinted egy átlagos héten?',
  why:'Ha a szervezet évek óta készenléti üzemmódban jár, a kedv hátrasorolódik — a rendszer azt üzeni: „nincs most idő rá”. Ez az egyik leggyakoribb rejtett háttérok.'},
 {id:'loading',type:'loading'},
 {id:'summary',type:'summary'},
 {id:'chart',type:'chart'},
 {id:'protocol',type:'protocol'}
];
var QCOUNT=STEPS.filter(function(s){return['age','single','multi','tried'].indexOf(s.type)>-1}).length;

/* ---------- Állapot ---------- */
var state={a:{},pos:0,_logged:false};

function esc(s){return String(s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
function labelFor(key,val){
  var list=OPTS[key]||[];
  for(var i=0;i<list.length;i++)if(list[i].k===val)return list[i].l||list[i].k;
  return val;
}
function ageImg(){
  var idx=0;
  for(var i=0;i<OPTS.age.length;i++)if(OPTS.age[i].k===state.a.age)idx=i;
  return AGE_IMGS[idx]||AGE_IMGS[1]||'';
}

/* ---------- Pontszám ---------- */
function derive(){
  var a=state.a,lvl=26;
  if(a.sexlife==='leallt')lvl-=12;else if(a.sexlife==='ritkabb')lvl-=7;else if(a.sexlife==='rutin')lvl-=3;else if(a.sexlife==='elegedett')lvl+=8;
  if(a.anx==='igen')lvl-=4;
  if(a.stressz==='folyamatos')lvl-=6;else if(a.stressz==='gyakran')lvl-=3;else if(a.stressz==='ritkan')lvl+=3;
  if(a.morning==='igen')lvl-=4;
  if(a.impact==='nagyon')lvl-=3;
  lvl=Math.max(7,Math.min(42,lvl));
  var trigger='Lassan kopó vitalitás';
  if(a.stressz==='folyamatos'||a.stressz==='gyakran'||a.anx==='igen')trigger='Tartósan magas stressz-szint';
  var zone=lvl<25?'Alacsony':'Normál alatti';
  return{lvl:lvl,trigger:trigger,zone:zone};
}

/* ---------- Naplózás (opcionális webhook) ----------
   - befejezett kitöltés: a betöltő képernyőnél megy be, statusz = "befejezte"
   - félbehagyott: az oldal elhagyásakor (bezárás, továbblépés, app-váltás),
     statusz = "félbehagyta", utolso_lepes = melyik kérdésnél tartott
   - a kitoltes_id köti össze, ha ugyanarról a kitöltésről több sor születik */
var SID=Math.random().toString(36).slice(2,10);
var lastSentSnapshot='';
function stepName(){
  var s=STEPS[state.pos];
  if(!s)return '';
  var qIdx=0;
  for(var i=0;i<=state.pos;i++)if(['age','single','multi','tried'].indexOf(STEPS[i].type)>-1)qIdx++;
  return s.q?(qIdx+'. kérdés: '+s.q):s.id;
}
function sendPayload(status){
  if(!WEBHOOK)return;
  var a=state.a;
  var done=status==='befejezte';
  var d=done?derive():null;
  var payload={
    kitoltes_id:SID,statusz:status,utolso_lepes:done?'vége':stepName(),
    ts:new Date().toISOString(),
    kor:a.age||'',fo_panasz:labelFor('fo',a.fo||''),porgo_agy:labelFor('anx',a.anx||''),
    hatas:labelFor('impact',a.impact||''),miota:labelFor('when',a.when||''),
    celok:(a.goal||[]).map(function(g){return labelFor('goal',g)}).join(', '),
    kapcsolat:labelFor('rel',a.rel||''),szexelet:labelFor('sexlife',a.sexlife||''),
    probalt:labelFor('tried',a.tried||''),reggeli:labelFor('morning',a.morning||''),
    stressz:labelFor('stressz',a.stressz||''),
    szint:done?d.lvl:'',hatterok:done?d.trigger:''};
  var body=JSON.stringify(payload);
  try{
    if(navigator.sendBeacon){
      navigator.sendBeacon(WEBHOOK,new Blob([body],{type:'text/plain;charset=utf-8'}));
    }else{
      fetch(WEBHOOK,{method:'POST',mode:'no-cors',keepalive:true,
        headers:{'Content-Type':'text/plain;charset=utf-8'},body:body});
    }
  }catch(e){}
}
function logAnswers(){
  if(!WEBHOOK||state._logged)return;
  state._logged=true;
  sendPayload('befejezte');
}
function maybeSendPartial(){
  if(!WEBHOOK||state._logged)return;
  var snap=JSON.stringify(state.a);
  if(snap==='{}'||snap===lastSentSnapshot)return;
  lastSentSnapshot=snap;
  sendPayload('félbehagyta');
}
document.addEventListener('visibilitychange',function(){
  if(document.visibilityState==='hidden')maybeSendPartial();
});
window.addEventListener('pagehide',maybeSendPartial);

/* ---------- Navigáció ---------- */
function progress(){
  var qIdx=0,total=QCOUNT,step=STEPS[state.pos];
  for(var i=0;i<=state.pos;i++)if(['age','single','multi','tried'].indexOf(STEPS[i].type)>-1)qIdx++;
  var show=['age','single','multi','tried','inter'].indexOf(step.type)>-1;
  pwrap.hidden=!show;
  if(show)pfill.style.width=Math.round(qIdx/total*100)+'%';
  if(step.type==='loading'||step.type==='summary'||step.type==='chart'||step.type==='protocol'){pwrap.hidden=false;pfill.style.width='100%';}
}
function next(){if(state.pos<STEPS.length-1){state.pos++;render();}}
function back(){if(state.pos>0){state.pos--;render();}}
function backBtn(){return '<button class="back" data-act="back">‹ Vissza</button>'}

/* ---------- Render ---------- */
function render(){
  var s=STEPS[state.pos];
  progress();
  root.scrollTop=0;
  var h='';
  if(s.type==='intro')h=rIntro();
  else if(s.type==='age')h=rAge(s);
  else if(s.type==='single')h=rSingle(s);
  else if(s.type==='multi')h=rMulti(s);
  else if(s.type==='tried')h=rTried(s);
  else if(s.type==='inter')h=rInter(s);
  else if(s.type==='loading')h=rLoading();
  else if(s.type==='summary')h=rSummary();
  else if(s.type==='chart')h=rChart();
  else if(s.type==='protocol')h=rProtocol();
  stage.innerHTML='<div class="screen">'+h+'</div>';
  wire(s);
}

function rIntro(){
  return '<div style="margin:auto 0">'
   +'<h1>Derítsd ki, mi nyomta el benned a <span class="accent">vágyat</span> — és hogyan kapod vissza.</h1>'
   +'<p class="sub">Válaszolj pár rövid kérdésre, és összeállítjuk a személyre szabott Shilami-protokollod. Nincs regisztráció, nincs kínos beszélgetés.</p>'
   +'<div class="meta"><span>⏱️ <b>~2 perc</b></span><span>🔒 <b>Névtelen</b></span><span>🌿 <b>Természetes</b></span></div>'
   +'<button class="btn btn--pulse" data-act="start">Kezdjük <span class="arr">→</span></button></div>';
}
function rAge(s){
  var h='<h2>'+esc(s.q)+'</h2><div class="grid2">';
  OPTS.age.forEach(function(o,i){
    var img=AGE_IMGS[i]||'';
    h+='<button class="agecard" data-val="'+o.k+'">'
      +(img?'<span class="ph"><img src="'+esc(img)+'" alt="'+o.k+'" loading="lazy" width="300" height="400"></span>':'')
      +'<span class="rng">'+o.k+'</span></button>';
  });
  return h+'</div>'+ (state.pos>1?backBtn():'');
}
function rSingle(s){
  var h='<h2>'+esc(s.q)+'</h2>'+(s.sub?'<p class="sub">'+esc(s.sub)+'</p>':'')+'<div class="opts">';
  OPTS[s.id].forEach(function(o){
    h+='<button class="opt" data-val="'+o.k+'">'+(o.em?'<span class="ico">'+o.em+'</span>':'')
      +'<span class="lbl">'+esc(o.l)+'</span><span class="ring"></span></button>';
  });
  h+='</div>';
  if(s.why)h+='<div class="why"><b>Miért kérdezzük?</b>'+esc(s.why)+'</div>';
  return h+backBtn();
}
function rMulti(s){
  var sel=state.a.goal||[];
  var h='<h2>'+esc(s.q)+'</h2><p class="sub">'+esc(s.sub||'')+'</p><div class="opts">';
  OPTS.goal.forEach(function(o){
    h+='<button class="opt'+(sel.indexOf(o.k)>-1?' is-sel':'')+'" data-val="'+o.k+'"><span class="lbl">'+esc(o.l)+'</span><span class="ring"></span></button>';
  });
  h+='</div><div style="margin-top:16px"><button class="btn" data-act="cont">Folytatom →</button></div>';
  return h+backBtn();
}
function rTried(s){
  var sel=state.a.tried;
  var h='<h2>'+esc(s.q)+'</h2><div class="opts">';
  OPTS.tried.forEach(function(o){
    h+='<button class="opt'+(sel===o.k?' is-sel':'')+'" data-val="'+o.k+'"><span class="lbl">'+esc(o.l)+'</span><span class="ring"></span></button>';
  });
  h+='</div><div id="shq-fb"></div>';
  if(sel)h+='<div style="margin-top:16px"><button class="btn" data-act="cont">Folytatom →</button></div>';
  return h+backBtn();
}
function rInter(s){
  var h='<div class="inter">'+(s.em?'<span class="bigem">'+s.em+'</span>':'')+'<h2>'+esc(s.h)+'</h2>';
  if(s.lead)h+='<p>'+esc(s.lead)+'</p>';
  if(s.blocks){
    s.blocks.forEach(function(b){
      h+='<div class="iblock"><span class="ie">'+b.em+'</span><div><b>'+esc(b.t)+'</b><p>'+esc(b.p)+'</p></div></div>';
    });
  }
  if(s.list){h+='<ul>';s.list.forEach(function(li){h+='<li><span>›</span>'+esc(li)+'</li>'});h+='</ul>';}
  if(s.note)h+='<div class="inote"><b>'+esc(s.note.t)+'</b><p>'+esc(s.note.p)+'</p></div>';
  if(s.p)h+='<p>'+esc(s.p)+'</p>';
  return h+'<button class="btn" data-act="cont">Folytatom →</button></div>';
}
function rLoading(){
  return '<div style="margin:auto 0"><h2>Összeállítjuk a profilod…</h2>'
   +'<p class="sub">A válaszaid alapján, pár másodperc.</p>'
   +'<div class="loadrows">'
   +'<div class="lrow" id="lr0"><b>Válaszok kiértékelése</b><span class="pct">0%</span></div>'
   +'<div class="lrow" id="lr1"><b>Háttérok azonosítása</b><span class="pct">0%</span></div>'
   +'<div class="lrow" id="lr2"><b>Protokoll összeállítása</b><span class="pct">0%</span></div>'
   +'</div></div>';
}
function rSummary(){
  var d=derive();
  var pos=Math.max(4,Math.min(96,d.lvl));
  var img=ageImg();
  return '<div class="sheet">'
   +'<div class="tag">A vitalitás-profilod összegzése</div>'
   +'<div class="rowline"><h2>Vitalitás-index</h2><span class="pill">'+esc(d.zone)+'</span></div>'
   +(img?'<div class="avatarwrap"><img src="'+esc(img)+'" alt="" loading="lazy" width="150" height="200"></div>':'')
   +'<div class="gauge" data-pos="'+pos+'"><div class="tip">A te szinted</div><div class="dot"></div></div>'
   +'<div class="gscale"><span>Alacsony</span><span>Normál</span><span>Jó</span><span>Kiváló</span></div>'
   +'<div class="alertbox"><b>❗ '+esc(d.zone)+' szint</b><p>A válaszaid alapján a rendszered régóta „készenléti üzemmódban” jár — ilyenkor a kedv és az energia hátrasorolódik. A jó hír: ez egy beragadt állapot, nem az öregség, és nem végleges.</p></div>'
   +'<div class="cells"><div class="cell c1"><div class="ct">Fejlődési tér</div><div class="cv">MAGAS</div></div>'
   +'<div class="cell c2"><div class="ct">⚡ Fő háttérok</div><div class="cv">'+esc(d.trigger)+'</div></div></div>'
   +'</div><button class="btn" data-act="cont">Folytatom →</button>';
}
function rChart(){
  var bars=[
    {w:'1-2. hét',h:30},{w:'3-4. hét',h:48},{w:'5-6. hét',h:66},{w:'7-8. hét',h:88,goal:true},{w:'9+ hét',h:97,last:true}
  ];
  var h='<h2>A terved: 60 nap, hogy újra önmagad legyél.</h2><div class="sheet"><div class="bars">';
  bars.forEach(function(b,i){
    h+='<div class="bar'+(b.goal?' goal':'')+(b.last?' last':'')+'"><div class="col" data-h="'+b.h+'" style="transition-delay:'+(i*120)+'ms">'+(b.goal?'<span class="goalb">Cél</span>':'')+'</div><span class="wk">'+b.w+'</span></div>';
  });
  h+='</div></div>'
   +'<p class="chartnote">A legtöbben <b>kb. 60 nap</b> alatt számolnak be érezhető változásról az energiájukban és a lendületükben — épp ezért jár minden csomaghoz <b>60 napos pénzvisszafizetési garancia</b>.</p>'
   +'<button class="btn" data-act="cont">Kérem a protokollom →</button>';
  return h;
}
function rProtocol(){
  var a=state.a,d=derive();
  var ageTxt=a.age?(a.age==='65+'?'65 felett jársz':a.age+' között jársz'):'';
  var stressTxt=(a.stressz==='folyamatos'||a.stressz==='gyakran')?'a tartós feszültség':'a lassan kopó lendület';
  var narr='A válaszaidból tiszta kép rajzolódik ki. '+(ageTxt?esc(ageTxt)+', és ':'')
   +'nem a vágy tűnt el belőled — <b>'+esc(stressTxt)+'</b> nyomta el. A rendszered „készenléti üzemmódban” ragadt, a kedv pedig hátrasorolódott. '
   +(a.tried==='tabletta'?'A tabletta eddig a tünetre ment — a terved most az okot célozza.':'Ez nem gyengeség és nem az öregség — és van belőle visszaút.');
  var url=PRODUCT_URL+(PRODUCT_URL.indexOf('?')>-1?'&':'?')+'utm_source=kviz&utm_medium=quiz&utm_campaign=vitalitas_kviz';
  return '<div class="sheet">'
   +'<div class="tag">A te Shilami-protokollod</div>'
   +'<h2>Személyre szabott terv, hogy újra az legyél, aki voltál</h2>'
   +'<div class="narr" style="margin-top:14px">'+narr+'</div>'
   +'<div class="mech"><span class="mi">🛡️</span><p><b>Nyugodtabb rendszer.</b> Ashwagandha — adaptogén gyökérkivonat, amit hagyományosan a stresszes, megterhelő időszakokban használnak.</p></div>'
   +'<div class="mech"><span class="mi">♂️</span><p><b>Férfierő-alap.</b> Cink, amely hozzájárul a vér normál tesztoszteronszintjének fenntartásához és a fáradtság csökkentéséhez.</p></div>'
   +'<div class="mech"><span class="mi">⛰️</span><p><b>Ősi vitalitás.</b> 3000 mg shilajit — fulvósavval és 85+ ásványi anyaggal, a Himalája „fekete aranya”.</p></div>'
   +'<div class="mech"><span class="mi">⚡</span><p><b>Lendület.</b> Maca és ginzeng — évszázadok óta használt növényi kivonatok a mindennapi vitalitásért.</p></div>'
   +'<div class="ingr">'
   +'<div class="ing"><b>Shilajit</b><span>3000 mg</span></div>'
   +'<div class="ing"><b>Ashwagandha</b><span>✓</span></div>'
   +'<div class="ing"><b>Maca</b><span>✓</span></div>'
   +'<div class="ing"><b>Ginzeng + Cink</b><span>✓</span></div>'
   +'</div>'
   +'<div class="offer">'+(BADGE?'<div class="badge">'+esc(BADGE.split(' ')[0])+'<small>'+esc(BADGE.split(' ').slice(1).join(' '))+'</small></div>':'')
   +'<div><h3>Shilajit Gold Gumivitamin</h3><div class="osub">Természetes, finom ízű — napi 2 gumivitamin'+(PRICE?' · <b>'+esc(PRICE)+'</b>':'')+(COMPARE?' <s>'+esc(COMPARE)+'</s>':'')+'</div></div></div>'
   +'<ul class="checks"><li>60 napos pénzvisszafizetési garancia</li><li>1-2 napos szállítás, utánvéttel is</li><li>Diszkrét csomagolás — senki nem tudja, mi van benne</li></ul>'
   +'<div class="guarantee">🛡️ Ha 60 napon belül nem érzed a különbséget, visszakapod az árát.</div>'
   +'</div>'
   +'<a class="btn btn--pulse" style="text-decoration:none" href="'+url+'">Megnézem a Shilajit Goldot <span class="arr">→</span></a>'
   +'<p class="disclaimer">A Shilajit Gold étrend-kiegészítő, nem gyógyszer, és nem helyettesíti a kiegyensúlyozott étrendet és az egészséges életmódot. Az eredmények egyénenként eltérhetnek.</p>';
}

/* ---------- Események ---------- */
function wire(s){
  stage.querySelectorAll('[data-act="back"]').forEach(function(b){b.addEventListener('click',back)});
  var start=stage.querySelector('[data-act="start"]');
  if(start)start.addEventListener('click',next);

  if(s.type==='age'){
    stage.querySelectorAll('.agecard').forEach(function(b){
      b.addEventListener('click',function(){
        b.classList.add('is-sel');
        state.a.age=b.getAttribute('data-val');
        setTimeout(next,220);
      });
    });
  }
  if(s.type==='single'){
    stage.querySelectorAll('.opt').forEach(function(b){
      b.addEventListener('click',function(){
        stage.querySelectorAll('.opt').forEach(function(x){x.classList.remove('is-sel')});
        b.classList.add('is-sel');
        state.a[s.id]=b.getAttribute('data-val');
        setTimeout(next,260);
      });
    });
  }
  if(s.type==='multi'){
    stage.querySelectorAll('.opt').forEach(function(b){
      b.addEventListener('click',function(){
        var v=b.getAttribute('data-val');
        var sel=state.a.goal||(state.a.goal=[]);
        if(v==='mind'){
          state.a.goal=sel.indexOf('mind')>-1?[]:OPTS.goal.map(function(o){return o.k});
        }else{
          var i=sel.indexOf(v);
          if(i>-1)sel.splice(i,1);else sel.push(v);
          var mi=sel.indexOf('mind');if(mi>-1)sel.splice(mi,1);
        }
        render();
      });
    });
    var c=stage.querySelector('[data-act="cont"]');
    if(c)c.addEventListener('click',function(){
      if((state.a.goal||[]).length===0){state.a.goal=['vagy'];}
      next();
    });
  }
  if(s.type==='tried'){
    stage.querySelectorAll('.opt').forEach(function(b){
      b.addEventListener('click',function(){
        state.a.tried=b.getAttribute('data-val');
        render();
        showFb();
      });
    });
    var c2=stage.querySelector('[data-act="cont"]');
    if(c2)c2.addEventListener('click',next);
    showFb();
  }
  function showFb(){
    if(!state.a.tried)return;
    var fb=TRIED_FB[state.a.tried],box=document.getElementById('shq-fb');
    if(fb&&box)box.innerHTML='<div class="feedback '+fb.cls+'"><b>'+(fb.cls==='warn'?'⚠️ ':'✅ ')+esc(fb.t)+'</b>'+esc(fb.p)+'</div>';
  }
  if(s.type==='inter'||s.type==='summary'||s.type==='chart'){
    var c3=stage.querySelector('[data-act="cont"]');
    if(c3)c3.addEventListener('click',next);
  }
  if(s.type==='summary'){
    var g=stage.querySelector('.gauge');
    if(g){
      var pos=g.getAttribute('data-pos');
      requestAnimationFrame(function(){requestAnimationFrame(function(){
        g.querySelector('.dot').style.left=pos+'%';
        g.querySelector('.tip').style.left=pos+'%';
        g.classList.add('is-on');
      });});
    }
  }
  if(s.type==='chart'){
    stage.querySelectorAll('.bar .col').forEach(function(c){
      requestAnimationFrame(function(){requestAnimationFrame(function(){
        c.style.height=c.getAttribute('data-h')+'%';
      });});
    });
  }
  if(s.type==='loading')runLoading();
}

/* ---------- Loading + mikro-megerősítések ---------- */
var MODALS=[
  {p:'Készen állsz rá, hogy újra az legyél, aki 35 évesen voltál?'},
  {p:'Tudtad, hogy 45 felett nagyjából minden harmadik férfi ugyanezzel küzd? Nem vagy egyedül.'},
  {p:'Belefér napi 10 másodperc, hogy visszahozd a lendületed?'}
];
function showModal(idx,done){
  var m=MODALS[idx];
  var bg=document.createElement('div');
  bg.className='modal-bg';
  bg.innerHTML='<div class="modal"><h3>Egy pillanat</h3><p>'+esc(m.p)+'</p>'
    +'<div class="mrow"><button class="mbtn no">Nem</button><button class="mbtn yes">Igen</button></div></div>';
  root.appendChild(bg);
  bg.querySelectorAll('.mbtn').forEach(function(b){
    b.addEventListener('click',function(){bg.remove();done();});
  });
}
function runLoading(){
  logAnswers();
  var rows=[sr.getElementById('lr0'),sr.getElementById('lr1'),sr.getElementById('lr2')];
  var modalAt=[35,70,92],shown=0,pcts=[0,0,0],cur=0,paused=false;
  var t=setInterval(function(){
    if(paused)return;
    if(cur>2){clearInterval(t);setTimeout(next,400);return;}
    pcts[cur]+=6+Math.round(Math.random()*6);
    if(pcts[cur]>=100){pcts[cur]=100;rows[cur].classList.add('done');rows[cur].querySelector('.pct').textContent='✓';cur++;}
    else rows[cur].querySelector('.pct').textContent=pcts[cur]+'%';
    var total=(pcts[0]+pcts[1]+pcts[2])/3;
    if(shown<MODALS.length&&total>=modalAt[shown]){
      paused=true;shown++;
      showModal(shown-1,function(){paused=false;});
    }
  },60);
}

render();
})();